// assets/eme-grid-switch.js
(() => {
  const STORAGE_KEY = "eme_grid_cols";

  const gridRoot =
    document.querySelector("#product-grid") ||
    document.querySelector('[id^="ProductGridContainer"] #product-grid') ||
    document.querySelector(".product-grid");

  if (!gridRoot) return;

  const pillWrap = document.querySelector(".eme-grid-pills");
  if (!pillWrap) return;

  const pills = [...pillWrap.querySelectorAll(".eme-pill-chip[data-grid]")];

  function apply(cols) {
    cols = String(cols);
gridRoot.classList.remove("eme-cols-2", "eme-cols-4", "eme-cols-6");
gridRoot.classList.add(`eme-cols-${cols}`);
    pills.forEach((b) => b.classList.toggle("is-active", b.dataset.grid === cols));

    try {
      localStorage.setItem(STORAGE_KEY, cols);
    } catch {}
  }

  let saved = null;
  try { saved = localStorage.getItem(STORAGE_KEY); } catch {}
  if (saved && ["2","4","6"].includes(saved)) apply(saved);
  else apply(pillWrap.querySelector(".eme-pill-chip.is-active")?.dataset.grid || "2");

  pillWrap.addEventListener("click", (e) => {
    const btn = e.target.closest(".eme-pill-chip[data-grid]");
    if (!btn) return;
    apply(btn.dataset.grid);
  });
})();